/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte Framework package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

import LatteUI, {Latte} from "@bybas/latte-ui";
import Vue from "vue";

window.Latte = Latte;

export function initializeApp()
{
	Vue.use(LatteUI, Object.assign({}, self.LatteOptions, {
		emojiBaseUrl: "https://bmcdn.nl/assets/joypixels/v5",
		emojiEnabled: false,
		root: "/dist/"
	}));

	return new Promise(resolve =>
	{
		window.addEventListener("DOMContentLoaded", () =>
		{
			resolve(new Vue({
				el: "main#app"
			}));
		});
	});
}
